module.exports = __webpack_public_path__ + "img/account-pane.cb17d5dd.png";